import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Footer } from '../Footer';
import toast from 'react-hot-toast';

export function SubscriptionSuccess() {
  const navigate = useNavigate();
  const { updateProfile } = useAuth();

  useEffect(() => {
    const handleSuccess = async () => {
      try {
        // Refresh profile to get updated subscription status
        await updateProfile();
        toast.success('Subscription upgraded successfully!');
        
        // Redirect to dashboard after a brief delay
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } catch (error) {
        console.error('Error updating profile:', error);
        toast.error('Please refresh the page to see your updated subscription');
      }
    };

    handleSuccess();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-bw-surface-subtle">
      <div className="flex-grow flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-bw-surface rounded-lg shadow-card p-8 text-center">
          <CheckCircle className="mx-auto h-12 w-12 text-success" />
          <h2 className="mt-4 text-2xl font-bold text-bw-ink">
            Subscription Upgraded!
          </h2>
          <p className="mt-2 text-bw-muted">
            Thank you for upgrading your subscription. You will be redirected to the dashboard shortly.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}